import { render, staticRenderFns } from "./EmployeeRecord.vue?vue&type=template&id=3d49d530&scoped=true"
import script from "./EmployeeRecord.vue?vue&type=script&lang=js"
export * from "./EmployeeRecord.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRecord.vue?vue&type=style&index=0&id=3d49d530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d49d530",
  null
  
)

export default component.exports